/* Polyfills for older browsers (Edge/Chrome < 93 on shop PCs) — must load before the app */
/* eslint-disable no-extend-native */
if (!Object.hasOwn) {
  Object.defineProperty(Object, "hasOwn", {
    value: (obj, key) => Object.prototype.hasOwnProperty.call(Object(obj), key),
    writable: true,
    configurable: true,
  });
}
if (!Array.prototype.at) {
  Object.defineProperty(Array.prototype, "at", {
    value: function at(n) { n = Math.trunc(n) || 0; if (n < 0) n += this.length; return (n < 0 || n >= this.length) ? undefined : this[n]; },
    writable: true,
    configurable: true,
  });
}
if (!String.prototype.at) {
  Object.defineProperty(String.prototype, "at", {
    value: function at(n) { n = Math.trunc(n) || 0; if (n < 0) n += this.length; return (n < 0 || n >= this.length) ? undefined : this.charAt(n); },
    writable: true,
    configurable: true,
  });
}
if (!String.prototype.replaceAll) {
  Object.defineProperty(String.prototype, "replaceAll", {
    value: function replaceAll(search, replacement) {
      if (search instanceof RegExp) return this.replace(search, replacement);
      return this.split(search).join(typeof replacement === "function" ? replacement(search) : replacement);
    },
    writable: true,
    configurable: true,
  });
}
if (!Array.prototype.findLast) {
  Object.defineProperty(Array.prototype, "findLast", {
    value: function findLast(fn, thisArg) { for (let i = this.length - 1; i >= 0; i--) { if (fn.call(thisArg, this[i], i, this)) return this[i]; } return undefined; },
    writable: true,
    configurable: true,
  });
}
if (!Array.prototype.findLastIndex) {
  Object.defineProperty(Array.prototype, "findLastIndex", {
    value: function findLastIndex(fn, thisArg) { for (let i = this.length - 1; i >= 0; i--) { if (fn.call(thisArg, this[i], i, this)) return i; } return -1; },
    writable: true,
    configurable: true,
  });
}
if (typeof window !== "undefined" && typeof window.structuredClone === "undefined") {
  window.structuredClone = (obj) => JSON.parse(JSON.stringify(obj));
}
